module.exports = __webpack_public_path__ + "img/ico-share01.9c363d9e.svg";